<template>
  <div class="flex flex-wrap gap-2 items-center">
    <label>
      Year:
      <select v-model="year" class="border rounded p-1">
        <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
      </select>
    </label>

    <label>
      Month:
      <select v-model="month" class="border rounded p-1">
        <option v-for="(name, index) in months" :key="index" :value="index + 1">
          {{ name }}
        </option>
      </select>
    </label>

    <label>
      Day:
      <select v-model="day" class="border rounded p-1">
        <option v-for="d in daysInMonth" :key="d" :value="d">{{ padZero(d) }}</option>
      </select>
    </label>

    <button
      @click="updateDate"
      class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
    >
      Update
    </button>
  </div>
</template>

<script>
export default {
  name: 'InsightsDateFilters',
  props: {
    value: {
      type: Object,
      default: () => {
        const today = new Date()
        return {
          year: today.getFullYear(),
          month: today.getMonth() + 1,
          day: today.getDate()
        }
      }
    },
    yearRange: {
      type: Number,
      default: 10
    }
  },
  data () {
    return {
      year: this.value.year,
      month: this.value.month,
      day: this.value.day,
      months: [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ]
    }
  },
  computed: {
    years () {
      const current = new Date().getFullYear()
      return Array.from({ length: this.yearRange }, (_, i) => current - i)
    },
    daysInMonth () {
      return Array.from({ length: new Date(this.year, this.month, 0).getDate() }, (_, i) => i + 1)
    }
  },
  watch: {
    year () {
      this.updateDaysInMonth()
    },
    month () {
      this.updateDaysInMonth()
    }
  },
  methods: {
    padZero (value) {
      return value.toString().padStart(2, '0')
    },
    updateDaysInMonth () {
      // Ensure day doesn't exceed the new month's days
      const maxDays = new Date(this.year, this.month, 0).getDate()
      if (this.day > maxDays) {
        this.day = maxDays
      }
    },
    updateDate () {
      this.$emit('input', {
        year: this.year,
        month: this.padZero(this.month),
        day: this.padZero(this.day)
      })
      this.$emit('update')
    }
  }
}
</script>

<style scoped>
label {
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/views/InsightsDateFilters.vue